/**
 * 业务公共的API
 */
import httpRequest from './httpRequest'

export default {
  //用户登录注册以及忘记密码功能区域---
  // 用户登陆接口
  login(payload) {
    return httpRequest.post('/api/login/login', payload).then((data) => {
      return data
    })
  },
  //获取角色列表
  getRoleInfoPage(payload) {
    return httpRequest.get('/api/roleInfo/getRoleInfoPage', payload).then((data) => {
      return data
    })
  },
  //保存角色信息
  saveRoleInfoEntity(payload) {
    return httpRequest.post('/api/roleInfo/saveRoleInfo', payload).then((data) => {
      return data
    })
  },
  //根据ID查角色信息
  getRoleInfoById(payload) {
    return httpRequest.get('/api/roleInfo/getRoleInfoById', payload).then((data) => {
      return data
    })
  },
  //删除角色信息
  deleteRoleInfoById(payload) {
    return httpRequest.get('/api/roleInfo/deleteRoleInfoById', payload).then((data) => {
      return data
    })
  },
  //查询角色无翻页全部
  getRoleInfoList(payload) {
    return httpRequest.get('/api/roleInfo/getRoleInfoList', payload).then((data) => {
      return data
    })
  },
  //启用禁用角色
  roleUpdateStatus(payload) {
    return httpRequest.get('/api/roleInfo/updateStatus', payload).then((data) => {
      return data
    })
  },
  //获取菜单全部列表
  getMenuPage(payload) {
    return httpRequest.get('/api/menu/getMenuPage', payload).then((data) => {
      return data
    })
  },
  //获取菜单全部树形结构
  getMenuList(payload) {
    return httpRequest.get('/api/menu/getMenuList', payload).then((data) => {
      return data
    })
  },
  //获取菜单列表
  getMenuByRoleId(payload) {
    return httpRequest.get('/api/menu/getMenuByRoleId', payload).then((data) => {
      return data
    })
  },
  //删除菜单
  deleteMenuById(payload) {
    return httpRequest.get('/api/menu/deleteMenuById', payload).then((data) => {
      return data
    })
  },
  //保存菜单信息
  saveMenuEntity(payload) {
    return httpRequest.post('/api/menu/saveMenu', payload).then((data) => {
      return data
    })
  },
  //查询菜单详情
  getMenuById(payload) {
    return httpRequest.get('/api/menu/getMenuById', payload).then((data) => {
      return data
    })
  },
  //查询用户列表
  getUserInfoPage(payload) {
    return httpRequest.get('/api/userInfo/getUserInfoPage', payload).then((data) => {
      return data
    })
  },
  //保存用户信息
  saveUserInfo(payload) {
    return httpRequest.post('/api/userInfo/saveUserInfo', payload).then((data) => {
      return data
    })
  },
  //删除用户信息
  deleteUserInfoById(payload) {
    return httpRequest.get('/api/userInfo/deleteUserInfoById', payload).then((data) => {
      return data
    })
  },
  //查询用户详情
  getUserInfoById(payload) {
    return httpRequest.get('/api/userInfo/getUserInfoById', payload).then((data) => {
      return data
    })
  },
  //查询101用户列表
  getParentUserInfoList(payload) {
    return httpRequest.get('/api/userInfo/getParentUserInfoList', payload).then((data) => {
      return data
    })
  },
  //启用禁用用户
  getParentUserInfoList(payload) {
    return httpRequest.get('/api/userInfo/updateStatus', payload).then((data) => {
      return data
    })
  },
  //修改用户密码
  updatePassword(payload) {
    return httpRequest.get('/api/userInfo/updatePassword', payload).then((data) => {
      return data
    })
  },
  //获取系统管理数据
  getSysManagementList(payload) {
    return httpRequest.get('/api/sysManagement/getSysManagementList', payload).then((data) => {
      return data
    })
  },
  //保存系统管理数据
  saveSysManagement(payload) {
    return httpRequest.post('/api/sysManagement/saveSysManagement', payload).then((data) => {
      return data
    })
  },
  //分页获取考评标准
  getEvaluationStandardPage(payload) {
    return httpRequest.get('/api/evaluationStandard/getEvaluationStandardPage', payload).then((data) => {
      return data
    })
  },
  //删除考评标准
  deleteEvaluationStandardById(payload) {
    return httpRequest.get('/api/evaluationStandard/deleteEvaluationStandardById', payload).then((data) => {
      return data
    })
  },
  //获取标准无分页数据
  getEvaluationStandardList(payload) {
    return httpRequest.get('/api/evaluationStandard/getEvaluationStandardList', payload).then((data) => {
      return data
    })
  },
  //启用禁用考评标准
  getEvaluationStandardPageUpdateStatus(payload) {
    return httpRequest.get('/api/evaluationStandard/updateStatus', payload).then((data) => {
      return data
    })
  },
  //保存获取考评标准
  saveEvaluationStandard(payload) {
    return httpRequest.post('/api/evaluationStandard/saveEvaluationStandard', payload).then((data) => {
      return data
    })
  },
  //根据id查询考评标准
  getEvaluationStandardById(payload) {
    return httpRequest.get('/api/evaluationStandard/getEvaluationStandardById', payload).then((data) => {
      return data
    })
  },
  // 分页获取考评计划
  getEvaluationPlanPage(payload) {
    return httpRequest.get('/api/evaluationPlan/getEvaluationPlanPage', payload).then((data) => {
      return data
    })
  },
  //考评计划目中考评项目
  getEvaluationProjectList(payload) {
    return httpRequest.get('/api/evaluationProject/getEvaluationProjectList', payload).then((data) => {
      return data
    })
  },
  //考评计划目中考评人员
  getEvaluationUserList(payload) {
    return httpRequest.get('/api/evaluationUser/getEvaluationUserList', payload).then((data) => {
      return data
    })
  },
  // 关联问题左边树形结构
  getQuestionList(payload) {
    return httpRequest.get('/api/questionOptions/getQuestionList', payload).then((data) => {
      return data
    })
  },
  // 关联问题右边表格
  getQuestionDetailName(payload) {
    return httpRequest.get('/api/questionOptions/getQuestionDetailName', payload).then((data) => {
      return data
    })
  },
  // 保存考评计划
  saveEvaluationPlan(payload) {
    return httpRequest.post('/api/evaluationPlan/saveEvaluationPlan', payload).then((data) => {
      return data
    })
  },
  //修改考评标准计划
  evaluationUpdateStatus(payload) {
    return httpRequest.get('/api/evaluationPlan/updateStatus', payload).then((data) => {
      return data
    })
  },
  // 根据id查询考评计划
  getEvaluationPlanById(payload) {
    return httpRequest.get('/api/evaluationPlan/getEvaluationPlanById', payload).then((data) => {
      return data
    })
  },
  //获取考评人员
  getUserInfoList(payload) {
    return httpRequest.get('/api/userInfo/getUserInfoList', payload).then((data) => {
      return data
    })
  },
  // 删除考评计划
  deleteEvaluationPlanById(payload) {
    return httpRequest.get('/api/evaluationPlan/deleteEvaluationPlanById', payload).then((data) => {
      return data
    })
  },
  // 删除考评计划
  deleteEvaluationPlanByIdConfirm(payload) {
    return httpRequest.get('/api/evaluationPlan/deleteEvaluationPlanByIdConfirm', payload).then((data) => {
      return data
    })
  },
  // 考评计划目中考评项目
  getEvaluationProjectList(payload) {
    return httpRequest.get('/api/evaluationProject/getEvaluationProjectList', payload).then((data) => {
      return data
    })
  },
  //考评计划目中考评人员
  getEvaluationUserList(payload) {
    return httpRequest.get('/api/evaluationUser/getEvaluationUserList', payload).then((data) => {
      return data
    })
  },
  // 根据id查询考评记录
  getEvaluationRecordId(payload) {
    return httpRequest.get('/api/projectInfo/getEvaluationRecordId', payload).then((data) => {
      return data
    })
  },

  //根据id查询变更记录
  getProjectChangeLog(payload) {
    return httpRequest.get('/api/projectChangeLog/getByProjectInfoId', payload).then((data) => {
      return data
    })
  },
  //项目保存
  saveProjectInfo(payload) {
    return httpRequest.post('/api/projectInfo/saveProjectInfo', payload).then((data) => {
      return data
    })
  },
  //项目列表
  getProjectInfoPage(payload) {
    let url = '/api/projectInfo/getProjectInfoPage'
    if (payload.detailedId) {
      url = '/api/home/getProjectInfoPage'
    }
    return httpRequest.get(url, payload).then((data) => {
      return data
    })
  },
  //项目详情
  getProjectInfoById(payload) {
    return httpRequest.get('/api/projectInfo/getProjectInfoById', payload).then((data) => {
      return data
    })
  },
  //删除项目
  deleteProjectInfoById(payload) {
    return httpRequest.get('/api/projectInfo/deleteProjectInfoById', payload).then((data) => {
      return data
    })
  },
  //考评记录
  getByProjectInfoId(payload) {
    return httpRequest.get('/api/projectInfo/getByProjectInfoId', payload).then((data) => {
      return data
    })
  },
  //问题选项配置列表
  getQuestionOptionsPage(payload) {
    return httpRequest.get('/api/questionOptions/getQuestionOptionsPage', payload).then((data) => {
      return data
    })
  },
  //保存问题选项配置列表
  saveQuestionOptions(payload) {
    return httpRequest.post('/api/questionOptions/saveQuestionOptions', payload).then((data) => {
      return data
    })
  },
  //删除问题选项配置列表
  deleteQuestionOptionsById(payload) {
    return httpRequest.get('/api/questionOptions/deleteQuestionOptionsById', payload).then((data) => {
      return data
    })
  },
  //禁用启用问题选项配置列表
  updateQuestionOptionsStatus(payload) {
    return httpRequest.get('/api/questionOptions/updateQuestionOptionsStatus', payload).then((data) => {
      return data
    })
  },
  //问题选项配置详情
  getQuestionOptionsById(payload) {
    return httpRequest.get('/api/questionOptions/getQuestionOptionsById', payload).then((data) => {
      return data
    })
  },
  //查询所有的一级类别
  getQuestionOptionsList(payload) {
    return httpRequest.get('/api/questionOptions/getQuestionOptionsList', payload).then((data) => {
      return data
    })
  }, //根据一级类别查询所有的二级类别
  getQuestionDetailedList(payload) {
    return httpRequest.get('/api/questionDetailed/getQuestionDetailedList', payload).then((data) => {
      return data
    })
  },
  //问题明细配置列表
  getQuestionDetailedPage(payload) {
    return httpRequest.get('/api/questionDetailed/getQuestionDetailedPage', payload).then((data) => {
      return data
    })
  },
  //保存问题明细配置
  saveQuestionDetailed(payload) {
    return httpRequest.post('/api/questionDetailed/saveQuestionDetailed', payload).then((data) => {
      return data
    })
  },
  //问题明细配置详情
  getQuestionDetailedById(payload) {
    return httpRequest.get('/api/questionDetailed/getQuestionDetailedById', payload).then((data) => {
      return data
    })
  },
  //删除问题明细配置
  deleteQuestionDetailedById(payload) {
    return httpRequest.get('/api/questionDetailed/deleteQuestionDetailedById', payload).then((data) => {
      return data
    })
  },
  //分页获取考评任务
  getEvaluationRecordPage(payload) {
    return httpRequest.get('/api/evaluationRecord/getEvaluationRecordPage', payload).then((data) => {
      return data
    })
  },
  //获取待办任务、任务详情数
  getEvaluationCount(payload) {
    return httpRequest.get('/api/evaluationRecord/getEvaluationCount', payload).then((data) => {
      return data
    })
  },
  //分页获取回头看任务
  getEvaluationBackPage(payload) {
    return httpRequest.get('/api/evaluationBack/getEvaluationBackPage', payload).then((data) => {
      return data
    })
  },
  //回头看业务任务详情
  getEvaluationBackById(payload) {
    return httpRequest.get('/api/evaluationBack/getEvaluationBackById', payload).then((data) => {
      return data
    })
  },
  //回头看业务考评详情
  getBackStandardAndResult(payload) {
    return httpRequest.get('/api/evaluationStandard/getBackStandardAndResult', payload).then((data) => {
      return data
    })
  },
  //回头看业务审核或批量审核
  evaluationBackUpdateStatus(payload) {
    return httpRequest.get('/api/evaluationBack/updateStatus', payload).then((data) => {
      return data
    })
  },
  //回头看业务导出
  evaluationBackUpExportInfo(payload) {
    return httpRequest.get('/api/evaluationBack/exportInfo', payload).then((data) => {
      return data
    })
  },
  //获取待办任务、任务详情数
  getEvaluationBackCount(payload) {
    return httpRequest.get('/api/evaluationBack/getEvaluationBackCount', payload).then((data) => {
      return data
    })
  },
  //
  getEvaluationBackCountPage(payload) {
    return httpRequest.get('/api/home/getEvaluationBackCountPage', payload).then((data) => {
      return data
    })
  },
  //业务管理考评计划搜索框全部
  getEvaluationPlanList(payload) {
    return httpRequest.get('/api/evaluationPlan/getEvaluationPlanList', payload).then((data) => {
      return data
    })
  },
  //当前计划考评标准一级分类列表接口
  getCategoryList(payload) {
    return httpRequest.get('/api/statics/firstCategoryList', payload).then((data) => {
      return data
    })
  },
  //当前计划考评标准一级分类列表接口
  getStreetList(payload) {
    return httpRequest.get('/api/staticsOut/streetList', payload).then((data) => {
      return data
    })
  },
  //业务管理考评项目搜索框全部
  getProjectInfoList(payload) {
    return httpRequest.get('/api/projectInfo/getProjectInfoList', payload).then((data) => {
      return data
    })
  },
  //考评计划添加项目
  getProjectList(payload) {
    return httpRequest.get('/api/projectInfo/getProjectList', payload).then((data) => {
      return data
    })
  },
  //首页数据统计
  getAllTotal(payload) {
    return httpRequest.get('/api/home/getAllTotal', payload).then((data) => {
      return data
    })
  },
  //首页问题细则出现数
  getDetailed(payload) {
    return httpRequest.get('/api/home/getDetailed', payload).then((data) => {
      return data
    })
  },
  //首页考评计划统计
  getTask(payload) {
    return httpRequest.get('/api/home/getTask', payload).then((data) => {
      return data
    })
  },
  //首页已检查任务统计
  getTaskCount(payload) {
    return httpRequest.get('/api/home/getTaskCount', payload).then((data) => {
      return data
    })
  },
  //日常考评业务审核或批量审核
  evaluationRecordUpdateStatus(payload) {
    return httpRequest.get('/api/evaluationRecord/updateStatus', payload).then((data) => {
      return data
    })
  },
  //日常考评业务详情
  getEvaluationRecordById(payload) {
    return httpRequest.get('/api/evaluationRecord/getEvaluationRecordById', payload).then((data) => {
      return data
    })
  },
  //日常考评业务根据计划id和项目id的日常考评任务详情
  getEvaluationStandardAndResult(payload) {
    return httpRequest.get('/api/evaluationStandard/getEvaluationStandardAndResult', payload).then((data) => {
      return data
    })
  },
  //项目导出
  exportProjectInfo(payload) {
    return httpRequest.get('/api/projectInfo/export', payload).then((data) => {
      return data
    })
  },
  //chart1
  getChart1(payload) {
    return httpRequest.get('/api/statics/scoreDistribution', payload).then((data) => {
      return data
    })
  },
  //chart2
  getChart2(payload) {
    return httpRequest.get('/api/statics/averageByStreet', payload).then((data) => {
      return data
    })
  },
  //chart3
  getChart3(payload) {
    return httpRequest.get('/api/statics/averageByType', payload).then((data) => {
      return data
    })
  },
  //chart4
  getChart4(payload) {
    return httpRequest.get('/api/statics/problemPercent', payload).then((data) => {
      return data
    })
  },
  //chart5
  getChart5(payload) {
    return httpRequest.get('/api/statics/problemNum', payload).then((data) => {
      return data
    })
  },
  //chart6
  getChart6(payload) {
    return httpRequest.get('/api/statics/scoreByYear', payload).then((data) => {
      return data
    })
  },
  //chart7
  getChart7(payload) {
    return httpRequest.get('/api/statics/scoreByFee', payload).then((data) => {
      return data
    })
  },
  //chart8
  getChart8(payload) {
    return httpRequest.get('/api/statics/averageByProperty', payload).then((data) => {
      return data
    })
  },
  //chart9
  getChart9(payload) {
    return httpRequest.get('/api/statics/problemPercentByFirst', payload).then((data) => {
      return data
    })
  },
  //chart10
  getChart10(payload) {
    return httpRequest.get('/api/statics/projectPercentNumAndPotoNum', payload).then((data) => {
      return data
    })
  },
  //chart11
  getChart11(payload) {
    return httpRequest.get('/api/evaluationPlan/getEvaluationProjectRankingTable', payload).then((data) => {
      return data
    })
  },
  //chart12
  getChart12(payload) {
    return httpRequest.get('/api/evaluationPlan/getEvaluationProjectNumTable', payload).then((data) => {
      return data
    })
  },
  //chart13
  getChart13(payload) {
    return httpRequest.get('/api/statics/problemPercentBySecond', payload).then((data) => {
      return data
    })
  },
  //chart14
  getChart14(payload) {
    return httpRequest.get('/api/statics/projectAllPercentNumAndPotoNum', payload).then((data) => {
      return data
    })
  },
  //lineChart1
  getlineChart1(payload) {
    return httpRequest.get('/api/statics/scoreByTask', payload).then((data) => {
      return data
    })
  },
  //项目导出模板
  downloadFileProjectInfo(payload) {
    return httpRequest.get('/api/projectInfo/downloadFile', payload).then((data) => {
      return data
    })
  },
  //项目导入模板
  projectImport(payload) {
    return httpRequest.post('/api/projectInfo/projectImport', payload).then((data) => {
      return data
    })
  },
  //日常考评任务导出
  exportEvaluationRecord(payload) {
    return httpRequest.get('/api/evaluationRecord/export', payload).then((data) => {
      return data
    })
  },
  //日常考评任务导出
  exportEvaluationRecordXls(payload) {
    return httpRequest.get('/api/evaluationRecord/exportXls', payload).then((data) => {
      return data
    })
  },
  //日常考评任务导出
  exportEvaluationBack(payload) {
    return httpRequest.get('/api/evaluationBack/export', payload).then((data) => {
      return data
    })
  },
  //考评计划导出
  exportEvaluationPlan(payload) {
    return httpRequest.get('/api/evaluationPlan/export', payload).then((data) => {
      return data
    })
  },
  //考评计划模板
  evaluationPlanEvaluationPlan(payload) {
    return httpRequest.get('/api/evaluationPlan/downloadFile', payload).then((data) => {
      return data
    })
  },
  //考评计划导入
  planImport(payload) {
    return httpRequest.post('/api/evaluationPlan/planImport', payload).then((data) => {
      return data
    })
  },
  //首页地图获取街道
  getStreet(payload) {
    return httpRequest.get('/api/projectInfo/getStreet', payload).then((data) => {
      return data
    })
  },
  //首页地图获取物业
  getProperty(payload) {
    return httpRequest.get('/api/projectInfo/getProperty', payload).then((data) => {
      return data
    })
  },
  //分页项目检查数据统计
  getProjectEvaluationCountPage(payload) {
    return httpRequest.get('/api/home/getProjectEvaluationCountPage', payload).then((data) => {
      return data
    })
  },
  //分页检查人员数据统计
  getUserEvaluationCountPage(payload) {
    return httpRequest.get('/api/home/getUserEvaluationCountPage', payload).then((data) => {
      return data
    })
  },
  //分页问题细则数据统计
  getDetailedPage(payload) {
    return httpRequest.get('/api/home/getDetailedPage', payload).then((data) => {
      return data
    })
  },
  getAllQuestionDetailedList(payload) {
    return httpRequest.get('/api/questionDetailed/getAllQuestionDetailedList', payload).then((data) => {
      return data
    })
  },
  //问题细则数据统计导出
  exportDetailed(payload) {
    return httpRequest.get('/api/home/exportDetailed', payload).then((data) => {
      return data
    })
  },
  //检查人员数据统计导出
  exportEval(payload) {
    return httpRequest.get('/api/home/exportEval', payload).then((data) => {
      return data
    })
  },
  //项目检查数据统计导出
  exportProjectCount(payload) {
    return httpRequest.get('/api/home/exportProjectCount', payload).then((data) => {
      return data
    })
  },
  //匹配项目模板下载
  downloadMatchFile(payload) {
    return httpRequest.get('/api/projectInfo/downloadMatchFile', payload).then((data) => {
      return data
    })
  },
  //匹配项目导入
  matchProjectList(payload) {
    return httpRequest.post('/api/projectInfo/matchProjectList', payload).then((data) => {
      return data
    })
  },
  getScoreStatistics(payload) {
    return httpRequest.get('/api/statics/scoreDistribution', payload).then((data) => {
      return data
    })
  },
  //考评标准模板导入
  standardImport(payload) {
    return httpRequest.post('/api/evaluationStandard/standardImport', payload).then((data) => {
      return data
    })
  },
  //考评标准模板下载
  evaluationStandardDownloadFile(payload) {
    return httpRequest.get('/api/evaluationStandard/downloadFile', payload).then((data) => {
      return data
    })
  },
  //获取项目市数量
  getProjectCount(payload) {
    return httpRequest.get('/api/projectInfo/getProjectCount', payload).then((data) => {
      return data
    })
  },
  //按项目性质、按项目街道、按区、按收费标准、按物业公司、按类型、按是否老旧小区、按交付时间区间
  getEvaluationProjectRankingTable(payload) {
    return httpRequest.get('/api/evaluationPlan/getEvaluationProjectRankingTable', payload).then((data) => {
      return data
    })
  },
  //获取区街道项目树形结构
  getDistrictList(payload) {
    return httpRequest.get('/api/projectInfo/getDistrictList', payload).then((data) => {
      return data
    })
  },
  //获取区街道项目树形结构右侧计划
  getEvaluationProjectIdPage(payload) {
    return httpRequest.get('/api/evaluationPlan/getEvaluationProjectIdPage', payload).then((data) => {
      return data
    })
  },
  //总分/现场/资料 联查
  exportByPlanId(payload) {
    return httpRequest.get('/api/evaluationRecord/exportByPlanId', payload).then((data) => {
      return data
    })
  },
  //获取联查详情
  getEvaluationStandardAndResultByPlanId(payload) {
    return httpRequest.get('/api/evaluationStandard/getEvaluationStandardAndResultByPlanId', payload).then((data) => {
      return data
    })
  },
  //首页搜索联动
  getArea(payload) {
    return httpRequest.get('/api/home/getArea', payload).then((data) => {
      return data
    })
  },
  //获取权限区
  getAreaList(payload) {
    return httpRequest.get('/api/home/getAreaList', payload).then((data) => {
      return data
    })
  },
  //获取任务列表
  getEvaluationTaskPage(payload) {
    return httpRequest.get('/api/evaluationTask/getEvaluationTaskPage', payload).then((data) => {
      return data
    })
  },
  //保存任务列表
  saveEvaluationTask(payload) {
    return httpRequest.post('/api/evaluationTask/saveEvaluationTask', payload).then((data) => {
      return data
    })
  },
  //任务列表获取详情
  getEvaluationTaskById(payload) {
    return httpRequest.get('/api/evaluationTask/getEvaluationTaskById', payload).then((data) => {
      return data
    })
  },
  //任务列表删除
  deleteEvaluationTaskById(payload) {
    return httpRequest.get('/api/evaluationTask/deleteEvaluationTaskById', payload).then((data) => {
      return data
    })
  },
  //查询任务列表
  getEvaluationTaskList(payload) {
    return httpRequest.get('/api/evaluationTask/getEvaluationTaskList', payload).then((data) => {
      return data
    })
  },
  //数据大屏获取数据详情
  getHomeProjectInfoById(payload) {
    return httpRequest.get('/api/projectInfo/getHomeProjectInfoById', payload).then((data) => {
      return data
    })
  },
  //数据大屏饼图点击获取项目列表
  getTaskProjectInfoList(payload) {
    return httpRequest.get('/api/home/getTaskProjectInfoList', payload).then((data) => {
      return data
    })
  },
  //获取每个区的项目数量
  getProjectCount(payload) {
    return httpRequest.get('/api/projectInfo/getProjectCount', payload).then((data) => {
      return data
    })
  },
  //分页获取合同列表接口
  getEvaluationContractPage(payload) {
    return httpRequest.get('/api/evaluationContract/getEvaluationContractPage', payload).then((data) => {
      return data
    })
  },
  //创建或更新合同信息接口
  saveEvaluationContract(payload) {
    return httpRequest.post('/api/evaluationContract/saveEvaluationContract', payload).then((data) => {
      return data
    })
  },
  //按id获取合同信息接口
  getEvaluationContractById(payload) {
    return httpRequest.get('/api/evaluationContract/getEvaluationContractById', payload).then((data) => {
      return data
    })
  },
  //根据id删除合同接口
  deleteEvaluationContractById(payload) {
    return httpRequest.get('/api/evaluationContract/deleteEvaluationContractById', payload).then((data) => {
      return data
    })
  },
  //不分页获取合同列表接口
  getEvaluationContractList(payload) {
    return httpRequest.get('/api/evaluationContract/getEvaluationContractList', payload).then((data) => {
      return data
    })
  },
  getHomeStreetList(payload) {
    return httpRequest.get('/api/home/getStreetList', payload).then((data) => {
      return data
    })
  },
  getPropertyList(payload) {
    return httpRequest.get('/api/home/getPropertyList', payload).then((data) => {
      return data
    })
  },
  copyEvaluationStandardById(payload) {
    return httpRequest.get('/api/evaluationStandard/copyEvaluationStandardById', payload).then((data) => {
      return data
    })
  },
  getFirstCategoryList(payload) {
    return httpRequest.get('/api/statics/firstCategoryList', payload).then((data) => {
      return data
    })
  },
  getProjectInfoPageByProblemDetail(payload) {
    return httpRequest.get('/api/projectInfo/getProjectInfoPageByProblemDetail', payload).then((data) => {
      return data
    })
  },
  getEvaluationBackPageCount(payload) {
    return httpRequest.get('/api/evaluationBack/getEvaluationBackPageCount', payload).then((data) => {
      return data
    })
  },
  deleteEvaluationRecordById(payload) {
    return httpRequest.get('/api/evaluationRecord/deleteEvaluationRecordById', payload).then((data) => {
      return data
    })
  },
  deleteEvaluationBackById(payload) {
    return httpRequest.get('/api/evaluationRecord/deleteEvaluationBackById', payload).then((data) => {
      return data
    })
  },
  exportList(payload) {
    return httpRequest.get('/api/evaluationRecord/exportList', payload).then((data) => {
      return data
    })
  },
  getSimpleProjectInfoList(payload) {
    return httpRequest.get('/api/projectInfo/getSimpleProjectInfoList', payload).then((data) => {
      return data
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/common/api.js